import { action, makeAutoObservable } from 'mobx';
import { RootStore } from './RootStore';
import { Role, User } from '../domain/User';
import { ServerStore } from './ServerStore';

export class UserStore {
    rootStore: RootStore;
    serverStore: ServerStore;
    users: User[] = [];
    roles: Role[] = [];
    userData: User = {
        id: -1,
        username: '',
        roles: [],
        loggedIn: false,
    };

    constructor(rootStore: RootStore, serverStore: ServerStore) {
        this.rootStore = rootStore;
        this.serverStore = serverStore;
        const savedUser = localStorage.getItem('userData');
        if (savedUser) {
            this.userData = JSON.parse(savedUser);
        }
        makeAutoObservable(this);
    }

    setUsername(username: string) {
        this.userData.username = username;
    }

    login(username: string, password: string, callback: (result: boolean, message?: string) => void) {
        this.serverStore.post('/login', { username, password }, action((data) => {
            this.userData = data;
            this.userData.loggedIn = true;
            localStorage.setItem('userData', JSON.stringify(this.userData));
            console.log(`User ${this.userData.username} is logged in`);
            this.rootStore.notificationsStore.add('user_logged_in', "success", { name: username });
            this.rootStore.prepareData();
            callback(true);
        }), action(() => {
            this.logout();
            callback(false, "Wrong username/password");
        }));
    }

    getMyUser(callback?: (user: User) => void) {
        this.serverStore.get('/users/my', action((user) => {
            this.userData = user;
            this.userData.loggedIn = true;
            localStorage.setItem('userData', JSON.stringify(this.userData));
            callback && callback(this.userData);
        }));
    }

    createUser(userData: any, callback: (result: boolean) => void) {
        this.serverStore.post('/register', userData, action((data) => {
            this.rootStore.notificationsStore.add('new_user_created', "success", { name: userData.username });
            callback(true);
            this.getAllUsers();
        }), () => {
            this.rootStore.notificationsStore.add('new_user_creation_failed', "error");
        });
    }

    updateUser(userData: any, callback?: (result: boolean) => void) {
        this.serverStore.put('/users/' + userData.id,
            userData,
            action(() => {
                callback && callback(true);
                this.rootStore.notificationsStore.add('user_is_updated', "success", { name: userData.username });
                this.getAllUsers();
            }));
    }

    deleteUser(user: User, callback?: (result: boolean) => void) {
        this.serverStore.delete('/users/' + user.id,
            action(() => {
                this.rootStore.notificationsStore.add('user_is_deleted', "success", { name: user.username });
                callback && callback(true);
                this.getAllUsers();
            }));
    }

    changePassword(password: string, callback: (result: boolean) => void) {
        this.serverStore.patch('/password', { password }, () => {
            this.rootStore.notificationsStore.add('password_changed_successfully', "success");
            callback(true);
        }, () => {
            this.rootStore.notificationsStore.add('failed_to_change_password', "error");
        });
    }

    logout() {
        this.serverStore.get('/logout', () => {
            console.log(`User ${this.userData.username} is logged out`);
        });
        this.userData.id = -1;
        this.userData.username = '';
        this.userData.webPushSubscriptionId = undefined;
        this.userData.roles = [];
        this.userData.loggedIn = false;
        this.rootStore.publisherStore.myPublisher = undefined;
        localStorage.removeItem('userData');
    }

    getAllRoles() {
        this.serverStore.get('/users/roles', action((data) => {
            this.roles = data;
        }));
    }

    getAllUsers() {
        this.serverStore.get('/users', action((data) => {
            this.users = data;
        }));
    }
}